import { useState, useEffect } from "react";
import { SEO, ImageArrayRender, Loading } from "../components";
import { useReleaseData, useSpotifyAccessToken } from "../hooks/useReleaseData";

const pageTitle = ["ALBUMS", "EPs and SINGLES", "FEATURING ON"];

export const Music = (props) => {
  const { project, config } = props;

  const [loading, setLoading] = useState(true);
  const seo = config?.SEO.discography;
  const accessToken = useSpotifyAccessToken();
  const artistId = config?.artistId;
  const releases = useReleaseData(artistId, accessToken);
  const albumsData = releases?.filter(
    (r) => r?.album_group === "album" || r?.album_group === "compilation"
  );
  const singlesData = releases?.filter((r) => r?.album_group === "single");
  const appearsOnData = releases?.filter(
    (r) => r?.album_group === "appears_on"
  );
  const dataGroups = [albumsData, singlesData, appearsOnData];

  useEffect(() => {
    if (releases && releases.length > 0) {
      setLoading(false);
    }
  }, [releases]);

  return (
    <div id="MusicPage" className="music-page">
      <SEO
        title={seo?.title}
        description={seo?.description}
        keywords={seo?.keywords}
        ogImage={`/assets/og_image/${project}_music.jpg`}
      />

      {loading ? (
        <Loading />
      ) : (
        <div className="music-container">
          {pageTitle.map((title, index) => (
            <ImageArrayRender
              key={index}
              project={project}
              data={dataGroups[index]}
              pageTitle={title}
            />
          ))}
        </div>
      )}
    </div>
  );
};
